import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[ceresColumnElement]',
    standalone: false
})
export class ColumnElementDirective {
    readonly self = inject(ElementRef);
}
